var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-snackbar",attrs:{"aria-live":"assertive","aria-atomic":"true","aria-hidden":"true"}},[_c('div',{staticClass:"mdc-snackbar__text"}),_vm._v(" "),_c('div',{staticClass:"mdc-snackbar__action-wrapper"},[_c('button',{staticClass:"mdc-button mdc-snackbar__action-button",attrs:{"type":"button"}})])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7062e5ee","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/snackbar/Snackbar.vue
// module id = 484
// module chunks = 8